import { render } from "./error.vue?vue&type=template&id=5c3e8091"
import script from "./error.vue?vue&type=script&lang=ts"
export * from "./error.vue?vue&type=script&lang=ts"
script.render = render

export default script